import React from "react";
import { useTranslation } from "react-i18next";

import Modal from "components/shared/Modal";
import List from "components/shared/List";

const ViewCollaterals = (props) => {
  const { t } = useTranslation();

  const noDataTitle = "noData";

  return (
    <Modal
      width="48.125rem"
      className="modal grey view-collaterals-modal"
      title={t("loanCollateralTitle")}
      visible={props.visible}
      okText={t("back")}
      cancelButtonProps={{
        className: "button button--default button--large",
        style: { visibility: "hidden" },
      }}
      okButtonProps={{
        className: "button button--primary button--large",
      }}
      onOk={() => {
        props.onClose();
      }}
    >
      <h4>{t("loanBillOfExchange")}</h4>
      <List
        className="view-collaterals-modal__list"
        noData={t(noDataTitle)}
        size="small"
        dataSource={props.billOfExchange}
      />

      <h4>{t("loanSurety")}</h4>
      <List
        className="view-collaterals-modal__list"
        noData={t(noDataTitle)}
        size="small"
        dataSource={props.guarantees}
      />

      <h4>{t("loanPledges")}</h4>
      <List className="view-collaterals-modal__list" noData={t(noDataTitle)} size="small" dataSource={props.pledges} />
    </Modal>
  );
};

export default ViewCollaterals;
